module.exports = __webpack_public_path__ + "img/map-marker-start.d02c7104.svg";